function base64ToArrayBuffer(base64) {
	var binary_string = window.atob(base64);//解码使用base64编码的字符串
	var len = binary_string.length;			//获取长度
	var bytes = new Uint8Array(len);
	for (var i = 0; i < len; i++) {
		bytes[i] = binary_string.charCodeAt(i);
	}
	return bytes.buffer;
}
export default {
	base64ToArrayBuffer
}


// WEBPACK FOOTER //
// ./static/js/function/base64.js